import React, { useState, useEffect } from 'react';

import { InputField, CheckBoxesField, MultiSelectField } from 'basics';

import { mergeRoles } from 'model/options';

import useFirestore from 'hooks/useFirestore';

export default function UserForm({ register, setValue, errors, item }) {
	const [userRoles, setUserRoles] = useState([]);

	const [awards, setAwards] = useState([]);

	const [showAwards, setShowAwards] = useState(false);

	const { getAwards } = useFirestore();

	const handleRoles = (label, value) => {

		if (label === "judge")
		{
			setShowAwards(value)
		}
	};

	useEffect(() => {

		const roles = mergeRoles(item && item.roles);

		setShowAwards(roles.some(role => role.value === "judge" && role.checked));

		setUserRoles(roles);

		getAwards(setAwards);

	}, [getAwards, item]);

	return (
		<>
			<InputField
				label="Nombre Completo"
				type="text"
				value={item && item.title}
				id="title"
				register={register}
				errors={errors}
				mode="dark"
				required={true}
			/>

			<InputField
				label="Email"
				type="text"
				value={item && item.email}
				id="email"
				register={register}
				errors={errors}
				mode="dark"
				required={true}
			/>

			<CheckBoxesField
				options={userRoles}
				register={register}
				error={errors.roles}
				id="roles"
				label="Roles"
				mode="dark"
				twoLines={true}
				onChange={handleRoles}
				required={true}
			/>

			{showAwards && <MultiSelectField
				options={awards}
				id="awards"
				label="Premios a evaluar"
				value={item && item.awards}
				required={true}
				register={register}
				error={errors.awards}
				mode="dark"
				columns={3}
				emptyMessage="No hay premios activos para asignar"
			/>}
		</>
	)
}